module.exports = __webpack_public_path__ + "img/train3.da450075.jpeg";